






















































































































































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import * as proxy from "@/lib/service-proxies/service-proxies";
import AppConsts from "@/lib/appconst";
import PagedFilterAndSortedRequest from "@/store/entities/page-request";
import pagelist from "@/components/pagelistcomponent";
import edit from "./ChannelsEdit.vue";
import ChannelBalanceAdjustOrderEdit from "@/views/ChannelManage/ChannelBalanceAdjustOrder/ChannelBalanceAdjustOrderEdit.vue";
import ChannelAdvanceMoneyAdjustOrderEdit from "@/views/ChannelManage/ChannelAdvanceMoneyAdjustOrder/ChannelAdvanceMoneyAdjustOrderEdit.vue";
import bindchannels from '@/views/ChannelManage/Channels/bindchannels.vue';
@Component({
  components: {
    edit,
    ChannelBalanceAdjustOrderEdit,
    ChannelAdvanceMoneyAdjustOrderEdit,
    bindchannels
  },
})
export default class suppliermanage extends pagelist {
  get prox() {
    return new proxy.ChannelServiceProxy();
  }
  pageSize = 50;
  input: proxy.ChannelPageInputDto = new proxy.ChannelPageInputDto();
  sub_id = 0;
  sub_rate = 0;
  qlShow = false;
  googlecode = '';
  channelRate = 0;
  createOrEditShow = false;
  AgentBalanceAdjustOrderEditshow = false;
  ChannelAdvanceMoneyAdjustOrderEditshow = false;
  channelId = 0;
  channelSuppliers = [];
  createrange = [];
  ctypes = [];
  apitypes = [];
  channeltypes = [];
  testladanshow = false;
  testladanreq = new proxy.CreatePayOrderInputDto();
  ladanres = new proxy.OrderSubmitPlatOutDto();
  marchants = [];
  quanzhongshow=false;
  Settlementshow = false;
  settlementreq = new proxy.ChannelSettlementPreMerInputDto();
  settlementPredatas = new proxy.ChannelSettlementPreOutDto();
  bindchannelsshow = false;
  selecttitles = []
  selectchannel:any={}
  quanzhong=0
  adjustRate = 0
 
  options3 = {
    disabledDate(date) {
      return (
        date &&
        (date.valueOf() < Date.now() - 86400000 * 2 ||
          date.valueOf() > Date.now())
      );
    },
  };
  columns=[]
  allcolumns = [
    {
      type: "selection",
      width: 60,
      align: "center",
      fixed: "left",
      title: "选择框"
    },

    // {
    //     title:'序号',
    //     width: 80,
    //     slot:'xuhao',
    //     fixed: 'left'
    // },
    {
      title: "名称",
      key: "name",
      width: 180,
      fixed: "left",
      sortable: "custom",
    },

    // {
    //   title: "通道ID",
    //   key: "id",
    //   width: 100,
    // },
    {
      title: '平台产品',
      slot: 'channelTypes',
      width: 220
    },
    {
      title: "通道供应商",
      key: "channelSupplierName",
      width: 120,
    },
    {
      title: "上游支付编码",
      key: "payCode",
      width: 140,
    },
    {
      title: "余额",
      slot: "balance",
      width: 130,
      sortable: "custom",
    },
    // {
    //   title: "预付",
    //   slot: "advanceMoney",
    //   width: 130,
    // },
    // {
    //   title: "实时余额",
    //   slot: "realBalance",
    //   width: 120,
    // },
    {
      title: '小时成功率(%)',
      key: 'hourSuccessRate',
      width: 130,
      sortable: "custom",
    },
    {
      title: '当天成功率(%)',
      key: 'daySuccessRate',
      width: 130,
      sortable: "custom",
    },
    {
      title:'权重',
      slot:'quanZhong',
      width:80,
    },
    {
      title: "状态",
      slot: "status",
      width: 100,
      sortable: "custom",
    },
    {
      title: "通道费率(%)",
      key: "rate",
      width: 120,
      sortable: "custom",
    },
    {
      title: "代理费率(%)",
      key: "agentRate",
      width: 120,
    },
    {
      title: "代理",
      key: "agentName",
      width: 150,
    },
    {
      title: "收款方式",
      slot: "shouKuanFangShi",
      width: 220,
    },
    // {
    //     title: '轮询权重',
    //     key: 'weight',
    //     width: 120
    // },
    {
      title: "群组id",
      key: "botId",
      width: 150,
    },
    {
      title: "创建时间",
      key: "creationTime",
      width: 180,
    },
    {
      title: "操作",
      slot: "oper",
      width: 290,
      fixed: "right",
    },
  ];
 
  updatequanzhong(){
    let req= new proxy.UpdateChannelQuanzhongInputDto();
    req.channelId=this.selectchannel.id;
    req.quanZhong=this.quanzhong;
    this.prox.updateChannelQuanzhong(req).then(x=>{
      this.$Notice.success({title:'修改成功'});
      this.getpage();
    })
  }
  openquanzhong(row){
     this.quanzhongshow=true;
     this.selectchannel=row;
     this.quanzhong=row.quanzhong || 1;
  }
  showbind(row) {
    this.sub_id = row.id;
    this.sub_rate  = row.rate;
    this.bindchannelsshow = true;
  }
  jsql() {
    if (this.selectedDataItems.length == 0) {
      this.$Notice.error({ title: "请选中数据" });
      return;
    }
    this.$Modal.confirm({
      title: "确定要结算清零通道余额吗？",
      onOk: () => {
        let ids = new proxy.IdsDto();
        ids.idList = this.selectedDataItems.map(x => {
          return x.id;
        })
        this.prox.channelbalanceqingling(ids).then(x => {
          this.$Notice.success({ title: '已结算清零' })
          this.getpage();
        })
      },
    });

  }

  unbundleLossMerchant() {
    if (this.selectedDataItems.length == 0) {
      this.$Notice.error({ title: "请选中数据" });
      return;
    }
    this.$Modal.confirm({
      title: '提醒',
      content: '确定解绑负利润商户',
      onOk: () => {
        var ids = new proxy.IdsDto();
        ids.idList = this.selectedDataItems.map(x => {
          return x.id;
        })
        this.prox.unbundleLossMerchant(ids).then(x => {
          this.$Notice.success({ title : '解绑负利润商户成功' })
          this.getpage();
        })
      }
    })
  }

  bindingAllMerchant(){
    if (this.selectedDataItems.length == 0) {
      this.$Notice.error({ title: "请选中数据" });
      return;
    }
    this.$Modal.confirm({
      title: '提醒',
      content: '该功能将为已绑定此通道产品的商户绑定通道!',
      onOk: () => {
        var ids = new proxy.IdsDto();
        ids.idList = this.selectedDataItems.map(x => {
          return x.id;
        })
        this.prox.bindingAllMerchant(ids).then(x => {
          this.$Notice.success({ title : '绑定商户成功' })
          this.getpage();
        })
      }
    })
  }

  adjustmentRate(){
    if (this.selectedDataItems.length == 0) {
      this.$Notice.error({ title: "请选中数据" });
      return;
    }
    this.$Modal.confirm({
      render: (h) => {
        return h('Input', {
          props: {
            placeholder: '基于通道原费率 上调/下调 费率，负数下调、正数上调'
          },
          on: {
            input: (val) => {
              this.adjustRate = val;
            }
          }
        })
      },
      onOk: () => {
        var ids = new proxy.IdsDto();
        ids.idList = this.selectedDataItems.map(x => {
          return x.id;
        })
        this.prox.adjustmentRate(this.adjustRate, ids).then(x => {
          this.$Notice.success({ title: '更改通道费率成功' })
          this.getpage();
        })
      },
    })
  }

  //修改通道费率
  updateChannelRate() {
    if (this.selectedDataItems.length == 0) {
      this.$Notice.error({ title: "请选中数据" });
      return;
    }
    this.$Modal.confirm({
      render: (h) => {
        return h('Input', {
          props: {
            placeholder: '一键修改通道费率%'
          },
          on: {
            input: (val) => {
              this.channelRate = val;
            }
          }
        })
      },
      onOk: () => {
        let ids = new proxy.UpdateChannelRateDto();
        ids.idList = this.selectedDataItems.map(x => {
          return x.id;
        })
        ids.rate = this.channelRate;
        this.prox.updateChannelRate(ids).then(x => {
          this.$Notice.success({ title: '更改通道费率成功' })
          this.getpage();
        })
      },
    })

  }
  okSettlement() {
    this.prox.settlement(this.settlementreq).then(x => {
      this.$Notice.success({ title: '结算成功' });
      this.getpage();
      this.Settlementshow = false;

    })
  }
  presettlement() {
    this.prox.settlementPre(this.settlementreq).then((x) => {
      this.settlementPredatas = x;
    });
  }
  openSettlementPre() {
    if (this.selectedDataItems.length == 0) {
      this.$Notice.error({ title: "请选中数据" });
      return;
    }
    this.settlementreq = new proxy.ChannelSettlementPreMerInputDto();
    this.settlementPredatas = new proxy.ChannelSettlementPreOutDto();
    this.settlementreq.channelIds = this.selectedDataItems.map((x) => {
      return x.id;
    });
    this.Settlementshow = true;
  }

  balanceReset() {
    let req = new proxy.IdsDto();
    req.idList = this.selectedDataItems.map((x) => {
      return x.id;
    });
    this.prox.googleCodeVerify(this.googlecode, req).then(x => {
      this.$Notice.success({ title: "操作成功" });
      this.getpage();
      this.googlecode = '';
      this.qlShow = false;
    })
  }

  qlGoogleCode() {
    if (this.selectedDataItems.length == 0) {
      this.$Notice.error({ title: "请选中数据" });
      return;
    }
    this.qlShow = true;
    this.googlecode = '';
  }

  handleSummary({ columns, data }) {
    const sums = {};

    return sums;
  }
  BatchStatusChange(e) {
    if (this.selectedDataItems.length == 0) {
      this.$Notice.error({ title: "请选中数据" });
      return;
    }
    let req = new proxy.IdsDto();
    req.idList = this.selectedDataItems.map((x) => {
      return x.id;
    });
    this.prox.batchStatusChange(e, req).then((x) => {
      this.$Notice.success({ title: "修改成功" });
      this.getpage();
    });
  }
  sortchange(a) {
    if (a.order == "desc") {
      this.sorting = (a.column.slot || a.column.key) + " desc, id desc";
    }
    if (a.order == "asc") {
      this.sorting = (a.column.slot || a.column.key) + " asc, id desc";
    }
    if (a.order == "normal") {
      this.sorting = "";
    }
    this.getpage();
  }
  okladan() {
    new proxy.PayOrderServiceProxy()
      .createOrder(this.testladanreq)
      .then((x) => {
        this.ladanres = x;
        this.$Notice.success({ title: "订单创建成功,可在[订单列表]查看" });
      });
  }
  ladan(row) {
    this.testladanreq.channelId = row.id;
    let req = new proxy.MerchantSimpleInputDto();
    req.status = 0;

    new proxy.MerchantServiceProxy().queryAllList(req).then((x) => {
      this.marchants = x;
    });
    let req2 = new proxy.ChannelTypePageInputDto();
    req2.isEnable = true;
    req2.maxResultCount = 1000;
    req2.sorting = 'code asc, id desc'
    new proxy.ChannelTypeServiceProxy().queryAllTypes(req2).then((x) => {
      this.ctypes = x;
    });
    this.testladanshow = true;
  }
  copyd(row) {
    this.prox.copyChannel(row.id).then((x) => {
      this.$Notice.success({ title: "复制成功" });
      this.getpage();
    });
  }
  adjadvanceMoney(row) {
    this.channelId = row.id;
    this.ChannelAdvanceMoneyAdjustOrderEditshow = true;
  }
  adjbalance(row) {
    this.channelId = row.id;
    this.AgentBalanceAdjustOrderEditshow = true;
  }
  statuschange(row, e) {
    if (e) {
      row.status = 0;
    } else {
      row.status = 1;
    }
    this.prox.createOrUpdate(row).then((x) => {
      this.$Notice.success({ title: "修改成功" });
      this.getpage();
    });
  }

  fetchDataList(
    request: PagedFilterAndSortedRequest,
    pageNumber: number,
    finishedCallback: Function
  ): void {
    this.input.skipCount = request.skipCount;
    this.input.maxResultCount = request.maxResultCount;
    this.input.createStartTime = this.createrange[0];
    this.input.createEndTime = this.createrange[1];
    this.input.sorting = request.sorting || 'status asc,Csort asc, id desc';
    this.prox.queryModelList(this.input).then((x) => {
      this.dataList = x.items;
      this.showPaging(x);
    });
  }

  getpage() {
    this.OnInit();
  }
  selecttitleschange() {
    this.columns = this.allcolumns.filter((x) =>
      this.selecttitles.includes(x.title)
    );
    localStorage.setItem("channel_columns", JSON.stringify(this.selecttitles));
  }
  beforeMount (){
    let columnscache = localStorage.getItem("channel_columns");
    if (!columnscache) {
      this.columns.push(...this.allcolumns);
      this.selecttitles = this.allcolumns.map((x) => {
        return x.title;
      });
    } else {
      let arr = JSON.parse(columnscache);
      this.selecttitles = arr;
      let arr2=[];
      this.allcolumns.forEach((x) => {
        if (arr.indexOf(x.title) != -1) {
          arr2.push(x);
        }
      });
      this.columns=arr2;
    }

   setTimeout(()=>{
    let req = new proxy.ChannelTypePageInputDto();
    req.maxResultCount = 100;

    // new proxy.CommonServiceProxy()
    //   .getEnumKeyValue("ChannelApiTypeEnum")
    //   .then((x) => {
    //     this.apitypes = x;
    //   });
    let creq = new proxy.ChannelTypePageInputDto();
    creq.maxResultCount = 2000;
    creq.sorting = 'code asc, id desc';
    new proxy.ChannelTypeServiceProxy().queryAllTypes(creq).then((x) => {
      this.channeltypes = x;
    });
    new proxy.ChannelSupplierServiceProxy().queryAllList().then(x => {
      this.channelSuppliers = x;
    })
   },2000)
  }
  async created() {
    
   
    this.getpage();
  }
  create() {
    this.createOrEditShow = true;
    this.sub_id = undefined;
  }
  edit(row) {
    if (!row) {
      if (this.selectedDataItems.length == 0) {
        this.$Notice.error({ title: "请选中一条数据" });
        return;
      }
      row = this.selectedDataItems[0];
    }
    this.sub_id = row.id;
    this.createOrEditShow = true;
  }

  del(row) {
    this.$Modal.confirm({
      title: "你确定要删除吗?删除后将无法恢复",
      onOk: () => {
        this.prox.deletes([row.id]).then(() => {
          this.$Notice.success({ title: "删除成功" });
          this.getpage();
        });
      },
    });
  }
}
